import { render, staticRenderFns } from "./ExportPatientData.vue?vue&type=template&id=7698f54c&"
import script from "./ExportPatientData.vue?vue&type=script&lang=js&"
export * from "./ExportPatientData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports